// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
import { ArrowLeftIcon, DismissIcon, Flex } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

import { useKioskSpacing } from '../../../hooks';
import { IconButton } from '../IconButton/IconButton';

type BaseModalHeaderProps = {
  nested?: boolean;
  onRequestClose(): void;
};

export type ModalHeaderProps = PropsWithChildren<BaseModalHeaderProps>;

export const ModalHeader = ({
  children,
  nested,
  onRequestClose,
}: ModalHeaderProps) => {
  const { defaultSpacing, getKioskSpacing, isIpad } = useKioskSpacing();
  const { colors } = useTheme();

  return (
    <Flex alignItems="center" p={defaultSpacing}>
      <IconButton
        backgroundColor={colors.grays.ultralight}
        onClick={onRequestClose}
        spacing={{
          marginRight: getKioskSpacing(24, 16),
          padding: getKioskSpacing(16, 12),
        }}
        style={{
          width: 'unset',
          height: 'unset',
        }}
        icon={
          nested ? (
            <ArrowLeftIcon
              altText="Back to previous modal"
              size={isIpad ? 'md' : 'lg'}
              data-testid="modal-header-back-icon"
            />
          ) : (
            <DismissIcon
              altText="Close Modal"
              size={isIpad ? 'md' : 'lg'}
              data-testid="modal-header-close-icon"
            />
          )
        }
      />

      {children}
    </Flex>
  );
};
